/**
 * Backup Types
 * Feature: 000-admin-backup
 *
 * Type definitions for the admin backup download feature.
 * Includes metadata, state management, and collection configuration types.
 */
/**
 * Backup format version for compatibility tracking
 */
export const BACKUP_VERSION = '1.0';
/**
 * Configuration for all Firestore collections to include in backup.
 */
export const BACKUP_COLLECTIONS = [
    { name: 'activity_log', yearSuffixed: true },
    { name: 'balances', yearSuffixed: false },
    { name: 'dashboard', yearSuffixed: false },
    { name: 'grades', yearSuffixed: false },
    { name: 'instructors', yearSuffixed: false },
    { name: 'notifications', yearSuffixed: false },
    { name: 'pricing', yearSuffixed: false },
    { name: 'standardOperatingHours', yearSuffixed: false },
    { name: 'specialOperatingHours', yearSuffixed: true },
    { name: 'transactions', yearSuffixed: true },
    { name: 'vouchers', yearSuffixed: false },
    { name: 'works', yearSuffixed: true },
];
